import { ICommonItem } from '../interfaces';
import { ENV } from '../config';

export const commonItemCourseData: ICommonItem[] = [
    {
        id: 'fc3c0155-9117-40d5-909f-54f98a1bf884',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/course_image_1.png`,
        href: '/courses/tong-hop-cac-san-pham-cua-hoc-vien-f8',
        btnContent: 'Xem bài viết',
        title: 'Tổng hợp các sản phẩm của học viên F8',
        course: {
            countRegister: 1000,
        },
    },
    {
        id: '6711c577-649e-439a-a823-3ffa4c2e0712   ',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/course_image_1.png`,
        href: '/courses/tong-hop-cac-san-pham-cua-hoc-vien-f8',
        btnContent: 'Xem bài viết',
        title: 'Tổng hợp các sản phẩm của học viên F8',
        course: {
            countRegister: 1000,
        },
    },
    {
        id: 'a64bb57a-2ee3-4263-89c3-431a71f52102',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/course_image_1.png`,
        href: '/courses/tong-hop-cac-san-pham-cua-hoc-vien-f8',
        btnContent: 'Xem bài viết',
        title: 'Tổng hợp các sản phẩm của học viên F8',
        course: {
            countRegister: 1000,
        },
    },
];

export const commonItemPostData: ICommonItem[] = [
    {
        id: '7d3ad9ab-f1a0-4255-803f-7080319445bc',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/tong-hop-cac-san-pham-cua-hoc-vien-tai-f8.png`,
        href: '/blog/tong-hop-cac-san-pham-cua-hoc-vien-tai-f8',
        btnContent: 'Xem bài viết',
        title: 'Tổng hợp các sản phẩm của học viên F8',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: 'a536fad7-a5e0-4a7a-a055-040e467fc611',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/phan-1-tao-du-an-reactjs-voi-webpack-va-babel.jpg`,
        href: '/blog/phan-1-tao-du-an-reactjs-voi-webpack-va-babel',
        btnContent: 'Xem bài viết',
        title: '[Phần 1] Tạo dự án ReactJS với Webpack và Babel',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: '635d364f-df0e-4836-bc83-6efd7ade5fcf',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/ky-su-ngay-thu-25-hoc-o-f8-1.png`,
        href: '/blog/ky-su-ngay-thu-25-hoc-o-f8-1',
        btnContent: 'Xem bài viết',
        title: 'Ký sự ngày thứ 25 học ở F8 ',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '12 Phút',
        },
    },
    {
        id: '763bcc16-ffe5-4383-838a-bac5a3f4708d',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/cach-dua-code-len-github-va-tao-github-pages.png`,
        href: '/blog/cach-dua-code-len-github-va-tao-github-pages',
        btnContent: 'Xem bài viết',
        title: 'Cách đưa code lên GitHub và tạo GitHub Pages',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: 'e49c7e50-9806-4605-84d2-8727e925c67c',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/cac-nguon-tai-nguyen-huu-ich-cho-1-front-end-developer.png`,
        href: '/blog/cac-nguon-tai-nguyen-huu-ich-cho-1-front-end-developer',
        btnContent: 'Xem bài viết',
        title: 'Các nguồn tài nguyên hữu ích cho 1 front-end developer',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: '261cf098-c0f4-428d-87c3-f1a26ab2f48f',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/thoi-gian-va-dong-luc.jpg`,
        href: '/blog/thoi-gian-va-dong-luc',
        btnContent: 'Xem bài viết',
        title: 'Thời gian và Động lực',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: '5ff1e29b-90c1-459b-9f22-9f3b8711be35',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/tong-hop-tai-lieu-tu-hoc-tieng-anh-co-ban.png`,
        href: '/blog/tong-hop-tai-lieu-tu-hoc-tieng-anh-co-ban',
        btnContent: 'Xem bài viết',
        title: 'Tổng hợp tài liệu tự học tiếng anh cơ bản.',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
    {
        id: 'cc912cab-6ea7-4878-ac7a-0d3eea562ef3',
        backgroundImage: `${ENV.apiUrl}/api/v1/file/hoc-nhu-the-nao-la-phu-hop.jpg`,
        href: '/blog/hoc-nhu-the-nao-la-phu-hop',
        btnContent: 'Xem bài viết',
        title: 'Học như thế nào là phù hợp ?',
        post: {
            author: 'Sơn Đặng',
            avatar: `${ENV.apiUrl}/api/v1/file/user-avatar.png`,
            time: '6 Phút',
        },
    },
];

export const commonItemVideoData: ICommonItem[] = [
    {
        id: '03579596-dff3-4587-82c9-2f5c4560ff27',
        backgroundImage: `https://i.ytimg.com/vi/YH-E4Y3EaT4/maxresdefault.jpg`,
        href: 'https://youtu.be/YH-E4Y3EaT4',
        btnContent: 'Xem Video',
        title: 'Sinh viên IT đi thực tập tại doanh nghiệp cần biết những gì?',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: '6939a839-4d15-4314-8dc9-43400ac788db',
        backgroundImage: `https://i.ytimg.com/vi/sgq7BH6WxL8/maxresdefault.jpg`,
        href: 'https://youtu.be/sgq7BH6WxL8',
        btnContent: 'Xem Video',
        title: '"Code Thiếu Nhi Battle" Tranh Giành Trà Sữa Size L',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: '53b1d66f-d1f2-4235-b757-0a87b8edcca2',
        backgroundImage: `https://i.ytimg.com/vi/DpvYHLUiZpc/maxresdefault.jpg`,
        href: 'https://youtu.be/DpvYHLUiZpc',
        btnContent: 'Xem Video',
        title: 'Phương pháp học lập trình của Admin F8?',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: 'de534558-ffab-4810-b782-53b590a0475c',
        backgroundImage: `https://i.ytimg.com/vi/R6plN3FvzFY/maxresdefault.jpg`,
        href: 'https://youtu.be/R6plN3FvzFY',
        btnContent: 'Xem Video',
        title: 'Bạn sẽ làm được gì sau khóa học?',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: '37ea47cf-0c88-4923-8fd9-79381b718495',
        backgroundImage: `https://i.ytimg.com/vi/oF7isq9IjZM/maxresdefault.jpg`,
        href: 'https://youtu.be/oF7isq9IjZM',
        btnContent: 'Xem Video',
        title: 'Làm sao để có thu nhập cao và đi xa hơn trong ngành IT?',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: '3fd78710-5eb7-4043-be78-d7354f878ab8',
        backgroundImage: `https://i.ytimg.com/vi/0SJE9dYdpps/maxresdefault.jpg`,
        href: 'https://youtu.be/0SJE9dYdpps',
        btnContent: 'Xem Video',
        title: 'Javascript có thể làm được gì? Giới thiệu qua về trang F8 | Học lập trình Javascript cơ bản',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: 'dd859bdb-ef2c-4e03-b25c-a89777c2e725',
        backgroundImage: `https://i.ytimg.com/vi/x0fSBAgBrOQ/maxresdefault.jpg`,
        href: 'https://youtu.be/x0fSBAgBrOQ',
        btnContent: 'Xem Video',
        title: 'ReactJS là gì? Tại sao nên học ReactJS?',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
    {
        id: '3a7f54ad-d42e-475c-92bf-6c8d1c7cec91',
        backgroundImage: `https://i.ytimg.com/vi/G19jZzK5FWI/maxresdefault.jpg`,
        href: 'https://youtu.be/G19jZzK5FWI',
        btnContent: 'Xem Video',
        title: 'Học Flexbox qua ví dụ',
        video: {
            view: 2000,
            like: 2000,
            comment: 2000,
            videoLength: '10:00',
        },
    },
];
